module.exports = __webpack_public_path__ + "img/FooterMobile1.325c60f9.png";